import axios from 'axios';
const URL_AUTH = process.env.VUE_APP_SERVER_URL_AUTH || 'https://fm-auth-dev.gofix.com.sg'
const state = {
    status: {
        loggingIn: false,
    },
    access_token: localStorage.getItem('access_token') || '',
    user: {},
    columns: [],
    roles: null,
    TableItems: {
        data: [],
        total: 0,
    },
    isFirstLogin: false
};

const getters = {
    isLoggedIn: state => !!state.access_token,
    user: state => state.user,
    columns: state => state.columns,
    roles: state => state.roles,
    TableItems: (state) => state.TableItems,
    isFirstLogin: (state) => state.isFirstLogin,
};

const actions = {
    loginTenant({ commit, state, dispatch }, params) {
        return new Promise((resolve, reject) => {
            // Validate.
            axios(URL_AUTH + `/api/login`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                // Error.
                .catch((error) => {
                    reject(error)
                });
        });
    },

    login({ commit, state, dispatch }, params) {
        // Validate and send the request.
        params.web_app = true;
        return new Promise((resolve, reject) => {
            // Validate.
            axios(URL_AUTH + `/api/login`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    // commit('setAccessToken', response.data.data.access_token);
                    // localStorage.setItem("access_token",response.data.data.access_token );
                    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.access_token;
                    // dispatch("getRoles");
                    resolve(response)
                })
                // Error.
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
        });
    },
    logout({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            axios(URL_AUTH + `/api/logout`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_roles');
                    localStorage.removeItem('user_info');
                    if (state.columns.length > 0) {
                        state.columns.forEach(item => {
                            if (localStorage.getItem(item)) {
                                localStorage.removeItem(item)
                            }
                        })
                    }
                    axios.defaults.headers.common['Authorization'] = '';
                    commit('setAccessToken', '');
                    commit('setUser', {});
                    commit('setColumns', []);
                    localStorage.clear();
                    resolve(response)
                })
                // Error.
                .catch((error) => {
                    commit('setUser', {})
                    commit('setAccessToken', '');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_roles');
                    localStorage.removeItem('user_info');
                    commit('setColumns', []);
                    axios.defaults.headers.common['Authorization'] = '';
                    reject(error)
                });
        });
    },
    checkUserExist({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            // Validate.
            axios(URL_AUTH + `/api/password/email`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
        });
    },
    resetPassword({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            // Validate.
            axios(URL_AUTH + `/api/password/reset`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
        });
    },
    getUser({ commit, state }, params) {
        // Validate and send the request.

        return new Promise((resolve, reject) => {

            // Validate.
            global.axios(`api/users/profile`, {
                    method: "GET",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    localStorage.setItem("user_info", JSON.stringify(response.data.data));
                    commit('setUser', response.data.data)
                    resolve(response)
                })
                // Error.
                .catch((error) => reject(error));
        });
    },
    getProfile({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            global.axios.post(`api/users/profile`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    getRoles({ commit, state }) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/roles/user`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    localStorage.setItem("user_roles", JSON.stringify(response.data.data));
                    commit('setRoles', response.data.data);
                    resolve(response)
                })
                // Error.
                .catch((error) => reject(error));
        });
    },
    async getTableItems({ commit }, params) {
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        return new Promise((resolve, reject) => {
            global.axios.get(`api/column-settings/table`, {
                    params: {
                        page: page,
                        limit: limit,
                        filter: filter,
                    }
                })
                .then(response => {
                    commit('setTableItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    getColumnSettingsUser({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/column-settings/${params}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    if (response.data.data.length > 0) {
                        let columns = []
                        response.data.data.forEach(item => {
                            localStorage.setItem(item.table_name, JSON.stringify(item.settings));
                            columns.push(item.table_name)
                        })
                        commit('setColumns', columns)
                    }
                    resolve(response)
                })
                // Error.
                .catch((error) => reject(error));
        });
    },
    getColumnSettingsTableUser({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/column-settings/show/${params.user_id}`, {
                    method: "GET",
                    params: {
                        table_name: params.table_name
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    commit('setColumnsV2', response.data.data)
                    resolve(response)
                })
                .catch((error) => reject(error));
        });
    },
    getNewColumnSettingsTableUser({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/new-column-settings/show/${params.user_id}`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    commit('setColumnsV2', response.data.data)
                    resolve(response)
                })
                .catch((error) => reject(error));
        });
    },
    resetDefaultColumnSettingsUser({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/column-settings`, {
                    method: "DELETE",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                // Error.
                .catch((error) => reject(error));
        });
    },
    updateColumnSettingsUser({ commit, state }, params) {
        // Validate and send the request.
        return new Promise((resolve, reject) => {
            // Validate.
            global.axios(`api/column-settings`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                // Error.
                .catch((error) => reject(error));
        });
    },
    verifyCode({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios(`api/users/verify-code`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then((response) => {
                resolve(response)
            })
            // Error.
            .catch((error) => reject(error));
        });
    },
    updateSecretKey({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios(`api/users/mfa`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then((response) => {
                resolve(response)
            })
            // Error.
            .catch((error) => reject(error));
        });
    },
    getQRCode({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios.post(`api/users/qr-code`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    getMFASecretKey({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios(`api/users/mfa`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    disableTwoFA({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios(`api/users/disable-two-factor-auth`,{
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    recoverSecret({ commit, state }, params){
        return new Promise((resolve, reject) => {
            global.axios(`api/users/recover-secret`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => reject(error));
        });
    }
};

const mutations = {
    setUser(state, data) {
        state.user = data
    },
    verifyCodeTwoFA(state, val){
        if(state.user){
            state.user.session_twofa = null;
        }   
    },
    setEnableMFA(state, val){
        if(state.user){
            state.user.microsoft2fa_enable = val;
        }   
    },
    setRoles(state, data) {
        state.roles = data
    },
    setColumns(state, data) {
        state.columns = data
    },
    setColumnsV2(state, data) {
        state.columns[data.table_name] = data

    },
    updateColumns(state, data) {
        if (!state.columns[data.table_name]) {
            state.columns[data.table_name] = data
            return
        }
        state.columns[data.table_name].settings = data.settings
            /*let tableNames = state.columns.filter(item => item == data);
            if(tableNames.length == 0) {
                state.columns.push(data)
            }*/
    },
    setAccessToken(state, data) {
        state.access_token = data;
    },
    setTableItems(state, data) {
        state.TableItems = data;
    },
    setIsFirstLogin(state, data) {
        state.isFirstLogin = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}